import React, { useState, useEffect, useRef,useContext } from 'react';
import {IProps} from './types';
import * as S from './styles';
import { useSelector } from 'react-redux';
import selectors from '@state/selectors';
import { DesignsContext } from '@utils/DOIgnition/DesignsContext';

const FoldersSearch:React.FC<IProps> = (props) => {
  const{ searchFolder, setSearchFolder, cleanFilters, setSortByQuery } = useContext(DesignsContext);
  const [selectedFolder, setSelectedFolder]= useState(0);
  const [showMenu, setShowMenu]= useState(false);
  const [folders, setFolders]= useState([] as any);
  const [tooltipText, seTooltipText]= useState(false);

  const foldersUser = useSelector(selectors.folders.getFolders);
  const folderUserUpdated = useSelector(selectors.folders.getFolder);
  const componentRef = useRef(null);
  const textFolder = useRef() as React.MutableRefObject<HTMLInputElement>;

  useEffect(() => {
    document.addEventListener("click", handleClickOuside);
    return () => document.removeEventListener("click", handleClickOuside);
  }, []);

  useEffect(() => {
    if (searchFolder==='') setSelectedFolder(0);
  }, [searchFolder]);

  const handleClickOuside = (e: any)=> {
    if(componentRef && componentRef.current){
        const ref: any = componentRef.current
        if(!ref.contains(e.target)){
          setShowMenu(false);
        }
    }
  }

  const tooltipValidate = () => {
    const compare = textFolder.current.scrollWidth > textFolder.current.clientWidth;
    if(compare)seTooltipText(true);
  };

  useEffect(() => {
    updateFolderList(foldersUser);
  }, [foldersUser]);

  useEffect(() => {
    updateFolderList(folderUserUpdated);
  }, [folderUserUpdated]);

  const updateFolderList = (foldersAdd:any) =>{
    if (foldersAdd && foldersAdd[0]) {
      let foldersOrder = [...foldersAdd[0].folders];
      foldersOrder.sort((a:any,b:any)=> (a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1));
      let foldersList = [{id: "all", name: "All My Designs", counter: 0},
                         {id: "favorite", name: "Favorites", counter: 0}] as any;
      foldersList.push(...foldersOrder);
      setFolders(foldersList);
    }
  } 

  const handleShowMenu = ()=> setShowMenu(!showMenu);

  const handleSelectFolder = (id:string, index:number) => {
    setSortByQuery('');
    setSearchFolder(id);
    setSelectedFolder(index);
    cleanFilters();
  }

  return (
    <S.Root ref={componentRef} onClick={handleShowMenu}>
        <S.Btn selected={showMenu} showText={selectedFolder>0 ? true : false}
            onMouseOver={()=>tooltipValidate()}
            onMouseOut={()=>seTooltipText(false)}>
              <S.Text ref={textFolder}  
                    selected={selectedFolder>0 ? true : false} >
                {selectedFolder>0 && folders[selectedFolder] ? folders[selectedFolder].name : ''}
              </S.Text>
              <S.Tooltip style={{display: tooltipText?'block':'none'}}>
                {selectedFolder>0 && folders[selectedFolder] ? folders[selectedFolder].name : ''}
              </S.Tooltip>
              <S.ArrowDown selected={selectedFolder>0 ? true : false}/>    
        </S.Btn>   
        <S.Menu style={{display: showMenu?'block':'none'}}>
        <S.Title>
          Search within a folder 
        </S.Title>  
        <S.OptionsContainer>
          {folders.map((item: any, idx: number)=>
          <S.Option key={`op${idx}`} 
            selected={idx===selectedFolder?true:false} 
            onClick={()=>handleSelectFolder(item.id, idx)}>
            {item.name}
          </S.Option>)}
        </S.OptionsContainer>
      </S.Menu>
    </S.Root>
  );
}

export default FoldersSearch;